import { useEffect, useState } from 'react';
import { useSpacerWidgetMutations } from '../../../../../mutations/widgets/spacer';
import {
  MAX_SPACER_WIDGET_HEIGHT,
  MIN_SPACER_WIDGET_HEIGHT,
} from '../../../../widgets/helpers';
import { useDebouncedCallback } from 'use-debounce';
import { Form, Input } from '@bynder/design-system';
import { Translate } from '@bynder/localization';

const SpacerHeightEditor: React.FC<{
  height: number;
  onChange: ReturnType<typeof useSpacerWidgetMutations>['resizeSpacerWidget'];
}> = ({ height, onChange }) => {
  const [spacerHeight, setSpacerHeight] = useState(height.toString());
  const handleMutation = () => {
    let widgetHeight = Number(spacerHeight);

    if (widgetHeight > MAX_SPACER_WIDGET_HEIGHT) {
      widgetHeight = MAX_SPACER_WIDGET_HEIGHT;
      setSpacerHeight(widgetHeight.toString());
    } else if (widgetHeight < MIN_SPACER_WIDGET_HEIGHT) {
      widgetHeight = MIN_SPACER_WIDGET_HEIGHT;
      setSpacerHeight(widgetHeight.toString());
    }

    onChange.mutate({ widgetHeight });
  };
  const handleResizeDivider = (newHeight: string) => {
    setSpacerHeight(newHeight);
    debouncedResize();
  };
  const debouncedResize = useDebouncedCallback(handleMutation, 1000);

  useEffect(() => {
    setSpacerHeight(height.toString());
  }, [height]);

  return (
    <Form.Group>
      <Form.Label htmlFor="heightInput">
        <Translate id="WIDGETS_INSPECTOR.HEIGHT_TITLE" />
      </Form.Label>
      <Input
        data-testid="spacerWidgetHeightInput"
        value={spacerHeight}
        onChange={handleResizeDivider}
        type="number"
        placeholder={spacerHeight}
        suffix="px"
        id="heightInput"
        aria-describedby="Height input"
      />
    </Form.Group>
  );
};

export default SpacerHeightEditor;
